import { BaseModalProps } from "../../../components/mplat/Modal";

export interface StorageItem {
    name: string,
    path: string | undefined,
    prefix: string | undefined,
    folder: boolean,
    linked: boolean,
    shared: boolean,
    operations: string,
    downloads: string,
    access: boolean,
    check: string,
    size: number | undefined,
    modTime: Date | undefined,
    fake?: boolean,
    preSignUrl?: string,
}

export interface StorageAccessModalProps extends BaseModalProps {
    path: string,
}

export type OperationModalType = 'copy' | 'move' | 'unzip' | 'copy-in-my' | 'none';

export enum SHOW_MODE {
    GRID = 'grid',
    LIST = 'list',
}
